import { cloneDeep } from "lodash";
import {
    allBudgetTypesOptions,
    allClassificationTypesOptions,
    allDataSourcesOptions,
    allMeasureUnitsOptions,
    allPeriodicitiesOptions,
    allReportNamesOptions,
    allReportTypesOptions,
} from "../../common/baseOptions";
import { Template } from "../../common/types/Template";
import { KsnFilterSettings } from "./settings/KsnFilterSettings";
import { KsnFilterOptions } from "./options/KsnFilterOptions";

const tempSettings: KsnFilterSettings = {
    reportName: 'KSN',
    reportType: 'REGULATED',
    classificationType: 'MIXED',
    dataSource: 'IISK',
    periodicity: 'PERIOD',
    bdate: null,
    edate: null,
    region: null,
    budgetTypes: [2, 3, 6],
    measureUnit: 'THOUSAND',
    roundUp: false,
    roundUpTo: null,
    sortByRegionCode: false,
}

export const ksnBaseTemplate: Template = {
    id: null,
    name: 'Информация о движении бюджетных средств областного бюджета',
    excelName: null,
    description: null,
    category: '50',
    regions: [],
    userId: '',
    filterSettings: tempSettings,
}

export const ksnFilterOptions: KsnFilterOptions = {
    key: 'KSN',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    regions: [],
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
}
